"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShippingOfferTooltip = void 0;
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _checkoutUtils = require("@ori/checkout-utils");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = require("react");
var _models = require("../../models");
var _utils = require("../../utils");
var _FormattedMessage = require("../FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const ShippingOfferIcon = (0, _mui.styled)('span')(({
  ownerState: {
    isDisabled
  },
  theme
}) => ({
  alignItems: 'center',
  background: theme.palette.offer.main,
  borderRadius: '50%',
  display: 'flex',
  height: 25,
  justifyContent: 'center',
  marginLeft: 'auto',
  width: 25,
  ...(isDisabled && {
    opacity: 0.5
  })
}));
const DiscountTag = (0, _mui.styled)(_icons.DiscountTagFilled)(({
  theme
}) => ({
  color: theme.palette.common.white,
  fontSize: '1.6rem'
}));
const ShippingOfferTooltip = ({
  isDisabled
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const [isTooltipOpen, setIsTooltipOpen] = (0, _react.useState)(false);
  const ownerState = {
    isDisabled
  };
  const {
    hasMouse
  } = (0, _checkoutUtils.useDeviceScreen)();
  const handleMouseEnter = () => {
    setIsTooltipOpen(true);
  };
  const handleMouseLeave = () => {
    setIsTooltipOpen(false);
  };
  const handleClick = e => {
    (0, _utils.stopSyntheticEvent)(e);
    setIsTooltipOpen(prevState => !prevState);
  };
  const iconProps = {
    onMouseEnter: hasMouse ? handleMouseEnter : undefined,
    onMouseLeave: handleMouseLeave,
    onClick: handleClick,
    ...getTestIdProps(isDisabled ? _models.TestId.ShippingOfferIconDisabled : _models.TestId.ShippingOfferIcon)
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Tooltip, {
    enterTouchDelay: 0,
    open: isTooltipOpen,
    title: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      id: "buyProductAndGetFreeDelivery"
    }),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ShippingOfferIcon, {
      ownerState: ownerState,
      ...iconProps,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(DiscountTag, {})
    })
  });
};
exports.ShippingOfferTooltip = ShippingOfferTooltip;